/*
 * CircuitEdit Messages
 *
 * This contains all the text for the CircuitEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteButton: {
    id: 'app.components.CircuitDeleteButton.deleteButton',
    defaultMessage: 'Delete',
  },
  deleteSuccess: {
    id: 'app.components.CircuitDeleteButton.deleteSuccess',
    defaultMessage: 'Circuit has been successfully deleted.',
  },
  deleteFailure: {
    id: 'app.components.CircuitDeleteButton.deleteFailure',
    defaultMessage: 'Error. The circuit could not be deleted.',
  },
  deleteConfirmTitle: {
    id: 'app.components.CircuitDeleteButton.deleteConfirmTitle',
    defaultMessage: 'Delete Circuit?',
  },
  deleteConfirmText: {
    id: 'app.components.CircuitDeleteButton.deleteConfirmText',
    defaultMessage: 'Deleting this circuit will permanently remove it.',
  },
  deleteConfirmDelete: {
    id: 'app.components.CircuitDeleteButton.deleteConfirmDelete',
    defaultMessage: 'Yes, Delete Circuit',
  },
  deleteConfirmCancel: {
    id: 'app.components.CircuitDeleteButton.deleteConfirmCancel',
    defaultMessage: 'No, Keep Circuit',
  },
});
